import {useTranslation} from 'next-i18next'
import {makeStyles} from '@material-ui/core/styles'
import AppTypography from 'src/components/elements/typography/AppTypography'
import {onUnknownChangeHandler} from 'src/utils/dom'

//todo convert to styles.module.css or tailwind utility classes
const useStyles = makeStyles(({spacing, palette}) => ({
  textArea: {
    width: '100%',
    height: spacing(19.5),
    border: `1px solid ${palette.grey[200]}`,
    borderRadius: spacing(1.5),
    padding: spacing(1.5, 2.5),
    resize: 'none',
  },
}))

export default function Message(props: {
  setMessage: (message: string) => void
  message?: string
  isQuestion?: boolean
}) {
  const {setMessage, message, isQuestion = false} = props

  const {t} = useTranslation(['common', 'booking'])
  const classes = useStyles()

  return (
    <div className="flex flex-col gap-1">
      <AppTypography variant="action" neutralColor={800}>
        {t(isQuestion ? 'question_to_host' : 'message_to_host')}
      </AppTypography>
      <textarea
        placeholder={t(
          isQuestion ? 'question_placeholder' : 'message_placeholder',
          {ns: 'booking'},
        )}
        className={classes.textArea}
        value={message ? message : undefined}
        onChange={onUnknownChangeHandler(setMessage)}
      />
    </div>
  )
}
